import { Result } from "antd";
import { BackToHomeButton, LogoutButton } from "components/Button";
import React from "react";
import { t } from "utils/i18n";

const Page403: React.FC = () => {
  return (
    <Result
      className="app-result-page"
      status="403"
      title="403"
      subTitle={t("PermissionDenied")}
      extra={
        <>
          <BackToHomeButton />
          <LogoutButton />
        </>
      }
    />
  );
};

export default Page403;
